import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Radio } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Switch } from "../ui/switch";

export const LiveToggle = () => {
  const [live, setLive] = useState({ on: false, message: "" });
  const [hasTiktok, setHasTiktok] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => {
      setLive(r.data?.live ?? { on: false, message: "" });
      setHasTiktok(!!r.data?.socials?.tiktok);
    }).catch(() => {});
  }, []);

  const save = async (next) => {
    setBusy(true);
    try {
      const r = await api.put("/admin/live", next);
      setLive(r.data.live);
      toast.success(r.data.live.on ? "Cartel de directo activado" : "Cartel de directo apagado");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="live-toggle" className={`mb-6 p-5 border flex flex-col md:flex-row md:items-center gap-4 transition-colors ${live.on ? "border-[#1FD1FF] bg-[#1FD1FF]/10" : "border-white/10 bg-[#0A1424]"}`}>
      <div className="flex items-center gap-4">
        <Switch checked={live.on} disabled={busy || !hasTiktok} onCheckedChange={(on) => save({ ...live, on })} data-testid="live-switch" aria-label="Estoy en directo" />
        <div>
          <p className="font-display text-3xl leading-none flex items-center gap-2"><Radio className={`w-5 h-5 ${live.on ? "text-[#1FD1FF] animate-pulse" : "text-[#A8B3C4]"}`} />{live.on ? "Estás en directo" : "Estoy en directo"}</p>
          <p className="text-xs text-[#A8B3C4] mt-1">{hasTiktok ? "Actívalo al empezar en TikTok y apágalo al terminar. Los fans verán un cartel arriba." : "Primero guarda tu enlace de TikTok en la pestaña Redes sociales."}</p>
        </div>
      </div>
      <div className="flex gap-2 md:ml-auto md:w-[420px]">
        <input value={live.message} maxLength={120} onChange={(e) => setLive({ ...live, message: e.target.value })} placeholder="Mensaje opcional: Sesión de dubstep hasta las 2am"
          data-testid="live-message-input" className="flex-1 min-w-0 bg-transparent border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:border-[#1FD1FF]" />
        <button data-testid="live-message-save" disabled={busy} onClick={() => save(live)} className="px-4 border border-[#1FD1FF] text-[#1FD1FF] font-mono text-xs uppercase hover:bg-[#1FD1FF] hover:text-black transition-colors">Guardar</button>
      </div>
    </div>
  );
};
